import { FormEvent, useState } from 'react'

import { Container, TransactionTypeContainer, RadioBox } from './styles'

import Modal from 'react-modal'

import closeImg from '../../assets/close.svg'
import incomeImage from '../../assets/income.svg'
import outcomeImage from '../../assets/outcome.svg'
import { useTransactions } from '../../hooks/useTransactions'


interface NewTransactionModalProps {
    isOpen: boolean;
    onRequestClose: () => void;
}

export function NewTransactionModal ({isOpen, onRequestClose}:NewTransactionModalProps) {

    const { createTransactions } = useTransactions()

    const [title, setTitle] = useState('')
    const [amount, setAmount] = useState(0)
    const [category, setCategory] = useState('')
    const [type, setType] = useState('deposit') 

    async function handleCreateNewTransaction (event:FormEvent) {
        event.preventDefault()

       await createTransactions({
            title,
            amount,
            category,
            type,
        });

        setTitle('');
        setAmount(0);
        setCategory('');
        setType('deposit');

        onRequestClose();
    }

    return (
        <Modal 
        isOpen={isOpen} 
        onRequestClose={onRequestClose}
        overlayClassName="reactModalOverlay"
        className="reactModalContent"

        >

            <button type="button" onClick={onRequestClose} className="reactModalClose">
                <img src={closeImg} alt="Fechar Modal"/>
            </button>

            <Container onSubmit={handleCreateNewTransaction}>

                <h2>Cadastrar Transação</h2>

                <input type="text" placeholder="Titulo" 
                value={title} 
                onChange={ event => setTitle(event.target.value) }/>  

                <input type="number" placeholder="Valor"
                value={amount} 
                onChange={ event => setAmount(Number(event.target.value)) }/> 

                <TransactionTypeContainer>

            <RadioBox
            type="button"
            onClick={() => {setType('deposit')}}   
            isActive={type === 'deposit'}
            activeColor="green"
            >
                <img src={incomeImage} alt="Entrada" />
                <span>Entrada</span>
            </RadioBox>

            <RadioBox
            type="button"
            onClick={() => {setType('withdraw')}}  
            isActive={type === 'withdraw'}
            activeColor="red"
            >
                 <img src={outcomeImage} alt="Saída" />
                 <span>Saída</span>
            </RadioBox>

             </TransactionTypeContainer>

             <input type="text" placeholder="Categoria"
              value={category} 
              onChange={ event => setCategory(event.target.value) }/> 

             <button type="submit"> Cadastrar </button>  
            </Container>

       </Modal>
    )
}